// extracted by mini-css-extract-plugin
export default {"spinner_container":"loading_spinner_container__VJp3i","spinner":"loading_spinner__w1XXT","spin":"loading_spin__wTEQG"};